module.exports = __webpack_public_path__ + "img/news04.0eca703.png";